import React from 'react';

import { ChevronBoldRightIcon } from '@motorway/mw-highway-code';

import { SimpleUspProps } from './SimpleUsp.types';

import styles from './SimpleUsp.module.scss';

export const SimpleUsp = ({ icon: Icon = ChevronBoldRightIcon, text, title }: SimpleUspProps) => (
  <div className={styles.component}>
    <div className={styles.usp}>
      <div className={styles.wrapper}>
        <Icon size='medium' />
        <h3 className={styles.title}>
          {title}
        </h3>
      </div>
      <p className={styles.text}>{text}</p>
    </div>
  </div>
);
